type PageLike = {
  __typename: string
  databaseId?: number | null
  template?: { templateName: string | null } | null
}

type ParentLike<T> = { children?: { nodes: T[] } | null } | {} | null | undefined

/**
 * Returns the sibling immediately after `currentId` (siblings are expected in menu order),
 * but only if it is a Page using `templateName`.
 */
export function getNextSiblingPage<T extends PageLike>(
  parent: ParentLike<T>,
  currentId: number | null | undefined,
  templateName: string,
) {
  const siblings = parent && "children" in parent ? parent.children?.nodes ?? [] : []
  const index = siblings.findIndex((node) => node.__typename === "Page" && node.databaseId === currentId)
  const next = index === -1 ? undefined : siblings[index + 1]
  if (next?.__typename !== "Page" || next.template?.templateName !== templateName) return undefined
  return next as Extract<T, { __typename: "Page" }>
}
